<!-- @format -->

<ng-container *transloco="let t">
  <ng-container [ngSwitch]="completionMethodNotification(data).type" *ngIf="courseUnit$ | async as data">
    <sis-study-notification-box *ngSwitchCase="'no-methods'" type="info">
      {{ t("PLAN.NO_COMPLETION_METHODS") }}
    </sis-study-notification-box>

    <sis-study-notification-box
      *ngSwitchCase="'missing-selection'"
      type="info"
      [primaryButtonText]="t('CONFIRM_AND_SELECT')"
      (primaryClickAction)="openSelectCompletionMethodModal()">
      {{ t("PLAN.MISSING_COMPLETION_METHOD") }}
    </sis-study-notification-box>

    <sis-study-notification-box
      *ngSwitchCase="'single-selected'"
      type="approved"
      [tertiaryButtonText]="t('PLAN.VIEW_COMPLETION_METHOD')"
      (tertiaryClickAction)="openSelectCompletionMethodModal()">
      {{ t("PLAN.COMPLETION_METHOD_CHOSEN", { completion_method_index: getCompletionMethodIndex(data) }) }}
    </sis-study-notification-box>

    <sis-study-notification-box
      *ngSwitchCase="'multiple-selected'"
      type="approved"
      [secondaryButtonText]="t('PLAN.CHANGE_COMPLETION_METHOD')"
      (secondaryClickAction)="openSelectCompletionMethodModal()">
      {{ t("PLAN.COMPLETION_METHOD_CHOSEN", { completion_method_index: getCompletionMethodIndex(data) }) }}
    </sis-study-notification-box>
  </ng-container>
</ng-container>
